import Draggable16 from '@carbon/icons-react/es/draggable/16';
import { List, Collapse } from 'antd';
import type { CollapseProps } from 'antd';
import styled from 'styled-components';
import { LinkButton } from 'components/atoms/button';
import { Menu } from 'components/atoms/dropdown';
import { RichTextEditor } from 'components/atoms/rich-text-editor';
import { TertiaryButton } from 'components/atoms/tertiary-button';

export const Row = styled.div<{ isOverlay: boolean }>`
  border-bottom: 1px solid var(--cool-gray-10);
  display: flex;
  gap: var(--spacing-07);
  padding: var(--spacing-03);
  align-items: flex-start;
  &:hover {
    cursor: grab;
    background-color: ${(props) =>
      props.isOverlay ? 'inherit' : 'var(--coolest-gray-10)'};
    .dragIcon {
      visibility: visible;
    }
  }
  & .dragIcon {
    visibility: hidden;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    margin-bottom: var(--cp-spacing-05);
    gap: var(--cp-spacing-03);
    padding-left: 0;
    padding-right: 0;
  }
`;
export const Col1 = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
  flex: 1 1 250px;
  min-width: 200px;

  @media (max-width: 480px) {
    flex: 1 1 auto;
  }
`;
export const Col2 = styled.div`
  width: 100%;
  flex: 2 1 auto;

  @media (max-width: 480px) {
    flex: 1 1 auto;
  }
`;
export const ProjectSummaryTitle = styled.div`
  color: var(--gray-100);
  padding-top: var(--spacing-03);
  font-size: var(--font-size-base);
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
`;
export const DragIcon = styled(Draggable16)`
  color: var(--gray-50);
`;
export const ProjectDetailsWrapper = styled.div`
  line-height: var(--line-height-base);
`;

export const OverlayWrapper = styled.div`
  background-color: var(--blue-60);
  color: var(--white-100);
  opacity: 0.8;
`;
export const ProjectSummaryWrapper = styled.div`
  overflow-y: hidden;
  position: relative;
`;
export const TextWrapper = styled.p`
  margin-bottom: 0;
`;
export const MultiSelectWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-03);
`;
export const DateWrapper = styled.div`
  width: 100%;
  padding-right: var(--spacing-03);
`;
export const StyledMenu = styled(Menu)`
  max-height: 444px;
  min-height: 444px;
  width: 256px;
  overflow-y: hidden;
  position: relative;
`;
export const StyledCollapse = styled(Collapse)<CollapseProps>`
  & .ant-collapse-arrow {
    padding: 0 !important;
    top: var(--spacing-03) !important;
    color: var(--gray-50) !important;
  }

  & .ant-collapse-header {
    padding: 6px 1rem !important;
    padding-left: 40px !important;
    line-height: var(--line-height-code-01);
  }
  & .ant-collapse-header:hover {
    background-color: var(--coolest-gray-10);
  }
  & .ant-collapse-content-box {
    padding: 0;
    padding-top: 0 !important;
  }
`;

export const SearchInput = styled.div`
  margin: var(--spacing-05);
  position: relative;
  box-shadow: var(--shadow-01);

  svg {
    position: absolute;
    right: var(--spacing-05);
    top: var(--spacing-04);
  }
  input {
    padding-right: var(--spacing-08);
    background-color: var(--gray-10);
  }
`;
export const StyledLinkButton = styled(LinkButton)`
  height: 20px;
`;
export const StyledButton = styled(TertiaryButton)`
  width: 240px;
  justify-content: center;
`;
export const ButtonWrapper = styled.div`
  position: absolute;
  bottom: 0;
  background-color: var(--white-100);
  width: 100%;
  display: flex;
  justify-content: center;
  height: 60px;
  align-items: center;
`;

export const ListContainer = styled(List)`
  margin-bottom: var(--spacing-06);
  flex: 1;
  max-height: 280px;
  padding-bottom: var(--spacing-05);
  overflow: scroll;
  margin-top: 0;
`;
export const MenuItem = styled.div`
  display: flex;
  align-items: baseline;
  width: 100%;
  gap: var(--spacing-03);
  padding: var(--spacing-03) var(--spacing-05);
  cursor: pointer;
  &:hover {
    background: var(--blue-10);
  }
  .ant-checkbox-wrapper {
    display: flex !important;
    align-items: center !important;
    width: 255px !important;
  }
  .ant-checkbox + span {
    max-width: 200px !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block !important;
  }
`;
export const Header = styled(Menu.Header)`
  margin: var(--spacing-05);
  padding: 0 !important;
`;

export const CollapseHeader = styled.div`
  color: var(--gray-50);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: var(--font-size-sm);
`;
export const Trigger = styled.div`
  color: var(--blue-60);
  margin: var(--spacing-04);
  width: fit-content;
  cursor: pointer;
`;
export const DndWrapper = styled.div`
  overflow-y: hidden;
  padding-top: var(--spacing-05);
`;
export const Rte = styled(RichTextEditor)`
  --rte-min-height: 16px;
  --rte-background: transparent;
  --rte-readonly-content-padding: 0 10% 0 0;
  max-width: 350px;
  .ck.ck-content {
    & > p {
      &:before {
        content: '';
      }
      &:after {
        content: '';
      }
    }
  }
`;
